import * as React from "react";
import styled from "styled-components";
import {Box} from "@material-ui/core";

export const BaseContainer = ({children}) => (
    <Box display={'flex'} flexDirection={'column'} flex={1}>
        <StyledContainer>
            {children}
        </StyledContainer>
    </Box>
);

const StyledContainer = styled("div")`
  border-radius: 3px;
  background-color: #fff;
  width: 100%;
  padding: 10px 20px;
  height: 100%;
  display: flex;
`;
